var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#k8bu56zw0a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.333 13a7.333 7.333 0 1 1-14.666 0 7.333 7.333 0 0 1 14.666 0z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.265 10.705V18h-4.21C9.475 18 9 17.535 9 16.965v-7.42c0-1.31.98-1.905 2.175-1.32L13.39 9.32c.48.235.875.86.875 1.385z",
    fill: "#1080FF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.875h-1.734a.378.378 0 0 1-.375-.375c0-.205.17-.375.375-.375H12.5a.374.374 0 1 1 0 .75zM12.5 13.875h-1.734a.378.378 0 0 1-.375-.375c0-.205.17-.375.375-.375H12.5a.374.374 0 1 1 0 .75zM19.016 14.525v2.225c0 .69-.56 1.25-1.25 1.25h-3.5v-5.79l.235.05 2.02.45.24.055 1.02.23a1.946 1.946 0 0 1 .67.265c.05.035.1.075.145.12.23.23.38.565.415 1.055 0 .03.005.06.005.09z",
    fill: "#1080FF",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "k8bu56zw0a",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3171_18818"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3171_18818",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessType);
export default __webpack_public_path__ + "static/media/business_type.7504a9a3fcd63b2174c27391883f74ee.svg";
export { ForwardRef as ReactComponent };